import {
  GLOBAL_COLOR_CANVAS_DEFAULT_DARK,
  GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
} from '@oneaudi/unified-web-common';

import { getThemeName } from '../../alpha-helper';

/**
 * Returns the proper background color for a given theme while respecting if the app
 * currently runs on alpha design or legacy design
 *
 * @param appTheme theme name for that the background color is to be looked up for
 * @returns
 */
export const getBackgroundColor = (appTheme?: 'light' | 'Light' | 'dark' | 'Dark'): string => {
  if (process.env.IS_LEGACY) {
    const themeName = getThemeName(appTheme);
    return themeName === 'light'
      ? GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT
      : GLOBAL_COLOR_CANVAS_DEFAULT_DARK;
  } else {
    return 'transparent';
  }
};
